import axios from "axios";
import { getToken, getUser } from "../../Utilities/Common";
import { getWithParamsAPICall, postAPICall, postAPICallwithFile } from "../axiosMethodCall";

export const getAssessmentHistory = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "assessments/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getAssessmentForPrint = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "assessments/get_for_print",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const printEkas = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "prints/pdf",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const printEpress = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "prints/pdf2",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getAbdomenLibrary = async () => {
  try {
    const payload = {
      requester: getUser(),
      token: getToken(),
    };
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "yakap_libraries/get_abdomen",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getSkinLibrary = async () => {
  try {
    const payload = {
      requester: getUser(),
      token: getToken(),
    };
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "yakap_libraries/get_skin",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getNeuroLibrary = async () => {
  try {
    const payload = {
      requester: getUser(),
      token: getToken(),
    };
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "yakap_libraries/get_neuro",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getHeentLibrary = async () => {
  try {
    const payload = {
      requester: getUser(),
      token: getToken(),
    };
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "yakap_libraries/get_heent",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getChestLungsLibrary = async () => {
  try {
    const payload = {
      requester: getUser(),
      token: getToken(),
    };
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "yakap_libraries/get_chest",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getCardiovascularLibrary = async () => {
  try {
    const payload = {
      requester: getUser(),
      token: getToken(),
    };
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "yakap_libraries/get_heart",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getRectalLibrary = async () => {
  try {
    const payload = {
      requester: getUser(),
      token: getToken(),
    };
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "yakap_libraries/get_rectal",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getGenitaliaLibrary = async () => {
  try {
    const payload = {
      requester: getUser(),
      token: getToken(),
    };
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "yakap_libraries/get_gu",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const createPhysicalExam = async (data, file) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "physical_exams/create",
      {
        requester: getUser(),
        token: getToken(),
        ...data,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const createPhysicalExamWithFile = async (data, file) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    Object.keys(data).forEach((key) => {
      if (data[key] !== undefined && data[key] !== null) {
        formData.append(key, data[key]);
      }
    });
    if (file) {
      formData.append("file", file);
    }
    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "physical_exams/create",
      formData
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const updatePhysicalExam = async (data, file) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    Object.keys(data).forEach((key) => {
      if (data[key] !== undefined && data[key] !== null) {
        formData.append(key, data[key]);
      }
    });
    if (file) {
      formData.append("file", file);
    }
    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "assessments/update",
      formData
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getDetailsForPE = async (data) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...data,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "physical_exams/get_past_details",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getPhysicalExam = async (params) => {
  try {
    const payload = {
      requester: getUser(),
      token: getToken(),
      patient_id: params.patient_id,
    }
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "physical_exams/get",
      payload
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
export const uploadEkasDocument = async (payload) => {
  try {
    // Add requester and token to FormData
    payload.append("requester", getUser());
    payload.append("token", getToken());

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "philhealth_reports/upload_document",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};